import { RouteUtils } from "~/utils/routes.utils";

export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) return;

  if (!/^\/stages\/[^/]+\/participants\/?$/.test(to.path)) return;

  const { isMobile } = useIsMobile();
  if (isMobile.value) return;

  const meetingId = useMeetingId();
  const { data: interns, suspense } = useInterns();

  if (suspense) {
    await suspense();
  }

  const firstIntern = interns.value?.[0];
  if (!firstIntern || !meetingId.value) return;

  const target = RouteUtils.getMeetingParticipant(
    meetingId.value,
    firstIntern.id,
  );

  if (to.fullPath !== target.path) {
    return navigateTo(target, { replace: true });
  }
});
